<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.service-clients.overview.title' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)">
    <e-columns>
      <e-column field='id'
        [visible]='false'
        headerText='ID'
        [isPrimaryKey]='true'></e-column>
      <e-column field='name'
        type="string"
        headerText="{{'i18n.shared.fields.name' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='address'
        type="string"
        headerText="{{'i18n.shared.fields.address' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='city'
        type="string"
        headerText="{{'i18n.shared.fields.city' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='email'
        type="string"
        headerText="{{'i18n.shared.fields.email' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
    </e-columns>
  </ejs-grid>
</div>
